'use strict';

/* eslint no-undef: "off" */
/**
 * common bottom sheet
 */
define('bottomSheet',['svgIcon'], function (svgIcon) {
  return {
    template: '\n      <transition name="xp-bottom-sheet-fade">\n        <div class="xp-bottom-sheet-mask" v-if="visible" @click="$emit(\'close\')">\n          <div class="xp-bottom-sheet-panel" :class="sheetClass" @click.stop>\n            <div class="xp-bottom-sheet-header">\n              <slot name="header">\n                <span class="xp-bottom-sheet-header-placeholder"></span>\n                <h3 v-text="title"></h3>\n              </slot>\n              <button type="button" class="xp-bottom-sheet-close" @click="$emit(\'close\')">\n                <svg-icon type="close"></svg-icon>\n              </button>\n            </div>\n            <div class="xp-bottom-sheet-body">\n              <slot></slot>\n            </div>\n            <div class="xp-bottom-sheet-footer" v-if="showConfirm || $slots.footer">\n              <slot name="footer">\n                <button type="button" class="xp-bottom-sheet-confirm" @click="$emit(\'confirm\')" v-text="confirmText"></button>\n              </slot>\n            </div>\n          </div>\n        </div>\n      </transition>\n    ',
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      title: {
        type: String,
        default: ''
      },
      confirmText: {
        type: String,
        default: 'Confirm'
      },
      showConfirm: {
        type: Boolean,
        default: true
      },
      sheetClass: {
        type: String,
        default: ''
      }
    },
    components: {
      svgIcon: svgIcon
    }
  };
});
